import React from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
const Result = ({ result, id, isRecommendation = false }) => {
    const article = result;
    const { tagsHeader, contentTypesHeader, recommendTagText } = useAppSelector((state) => state.pageSettings);
    const recommendedLabel = recommendTagText?.trim() || 'Recommended';

    return (
        <li key={article.index} id={id} className="search-result-item">
            <div className="search-result-item-content stack-md">
                <div className="search-result-item-content stack-md">
                    {article.contentType && <p className="label brand-red">{article.contentType}</p>}
                    {article.title && article.url ? (
                        <a href={article.url}>
                            {' '}
                            <h3 className="h6-style space-top-md">{article.title}</h3>
                        </a>
                    ) : (
                        <h3 className="h6-style">{article.title}</h3>
                    )}
                    {article.imageUrl == null && isRecommendation && (
                        <span className="search-result-image-tag search-result-image-tag-standard label">{recommendedLabel}</span>
                    )}
                    {article.date && <p>{article.date}</p>}
                    {article.venue && <p className="bold"> {article.venue} </p>}
                    {article.summary && <p dangerouslySetInnerHTML={{ __html: article.summary }} />}
                    {article.author && <p> {article.author} </p>}

                    {article.tags && article.tags.length > 0 && (
                        <>
                            <ul className="otc-card-categories">
                                <li>{tagsHeader}:</li>
                                {article.tags.map((tag, index) => (
                                    <li key={index} className="bold">
                                        {tag}
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </div>
            </div>
            {article.imageUrl != null && (
                <div className="search-result-image">
                    <img
                        src={article.imageUrl}
                        alt={article.imageAltText || article.title}
                        style={{ objectPosition: article.imageFocalPoint || '' }}
                    />
                    {isRecommendation && <span className="search-result-image-tag label">{recommendedLabel}</span>}
                </div>
            )}
        </li>
    );
};

export default React.memo(Result);
